// extracted by mini-css-extract-plugin
export default {"navigation":"Navigation_navigation__A20oB","hidden":"Navigation_hidden__Km+cv","hamburger":"Navigation_hamburger__rSl1p"};